import * as React from "react";

const ReservationContext = React.createContext<any>(null);

interface IReservationProvider {
  children?: React.ReactNode;
}

const ReservationContextProvider: React.FC<IReservationProvider> = (props) => {
  const [reservationExpiry, setReservationExpiry] = React.useState(null);
  const [reservationHasExpired, setReservationHasExpired] = React.useState(false);

  const provided = React.useMemo(
    () => ({
      reservationExpiry,
      setReservationExpiry,
      reservationHasExpired,
      setReservationHasExpired,
    }),
    [reservationExpiry, reservationHasExpired],
  );

  return (
    <ReservationContext.Provider
      value={{
        provided,
      }}
    >
      {props.children}
    </ReservationContext.Provider>
  );
};

const useReservationContext = () => React.useContext(ReservationContext);

export { ReservationContextProvider, useReservationContext };
